<template>
  <div>
    <div class="limiter margin-block-1">
      <h2 class="text-3 tw-text-blue tw-font-bold">
        Important :
      </h2>
      <p class="text-2">
          L'Enfance des arts est avant tout une invitation à faire un pas de côté. La mise en place d'une simple représentation n'est donc pas suffisante pour participer. Les projets proposés doivent croiser les disciplines, être participatifs, collaboratifs, innovants... et permettre la mise en place de nouveaux partenariats. Intitulée “L’Enfance des arts en jeux !”, l’édition 2024 vous invite par ailleurs à explorer les différentes facettes du jeu, et vous donne notamment la possibilité d’inscrire votre événement dans l’Olympiade Culturelle pour bénéficier d’une plus grande visibilité.
      </p>
    </div>
    <NewEventForm/>
  </div>
</template>

<script>
import NewEventForm from "../components/Form/NewEventForm";
export default {
  name: "CreateNew",
  components: {NewEventForm}
}
</script>

<style scoped>

</style>